import { FC, memo, useEffect } from 'react'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Dialog } from '@ucheba/ui/components/Dialog/desktop'
import { useSelector } from 'react-redux'
import { probabilitiesSelectors } from '@ucheba/store/probabilities'
import { authSelectors } from '@ucheba/store/auth'
import { useRouter } from 'next/router'
import { getParsedCookies } from '@ucheba/utils/helpers/core'
import { authCookieToken } from '@ucheba/utils/constants/core'
import { IOddsAssessment } from '../types'
import { useOddsAssessment } from '../bll'
import SelectDialog from '../components/SelectDialog/desktop'
import OddsAssessmentResults from '../components/OddsAssessmentResults/desktop/OddsAssessmentResults'
import OddsAssessmentResultButton from './OddsAssessmentResultButton'

/** Кнопка для оценки шансов поступить на программу */
const OddsAssessment: FC<IOddsAssessment> = (props) => {
  const {
    children,
    requiredExams,
    optionalExams,
    programId,
    selectedExams,
    achievements,
    institutionsName,
    programName,
    programIds,
    view,
    justifyContent,
  } = props

  const { query } = useRouter()

  const {
    resultsDialog,
    onOpenResultsDialog,
    selectEgeDialog,
    probability,
    hasCurrentProbability,
    checkAuth,
    getAchievements,
    onClose,
    onCloseSelectEgeDialog,
    handleCloseSelectEgeDialog,
  } = useOddsAssessment(programId)

  useEffect(() => {
    if (query.showOddsStep1) {
      if (hasCurrentProbability) {
        setTimeout(async () => {
          resultsDialog.openDialog()
        }, 500)
      } else {
        setTimeout(async () => {
          selectEgeDialog.openDialog()
        }, 500)
      }
    }
  }, [])

  const isAuth = useSelector(authSelectors.isAuth)
  const anotherPrograms = useSelector(probabilitiesSelectors.anotherPrograms)

  useEffect(() => {
    if (query.showOddsStep1 && isAuth) {
      getAchievements()
    }
  }, [getAchievements, isAuth, query.showOddsStep1])

  return (
    <>
      {hasCurrentProbability && probability ? (
        <OddsAssessmentResultButton
          onClick={onOpenResultsDialog}
          onReset={() => {
            const parsedCookie = getParsedCookies()
            const tokenString = parsedCookie[authCookieToken]

            if (!isAuth || !tokenString) {
              checkAuth()
            } else {
              selectEgeDialog.openDialog()
            }
          }}
          probability={probability}
        />
      ) : (
        <Button
          color='blue'
          block
          view={view}
          justifyContent={justifyContent}
          onClick={() => {
            const parsedCookie = getParsedCookies()
            const tokenString = parsedCookie[authCookieToken]
            if (!isAuth || !tokenString) {
              checkAuth()
            } else if (!hasCurrentProbability) {
              selectEgeDialog.openDialog()
            } else {
              resultsDialog.openDialog()
            }
          }}
          size='small'
        >
          {children}
        </Button>
      )}

      <Dialog
        open={resultsDialog.isActive}
        onClose={onClose}
        scrollY={!!(anotherPrograms && anotherPrograms.length > 0)}
        overflow='hidden'
        spacing='null'
      >
        <OddsAssessmentResults
          institutionsName={institutionsName}
          programName={programName}
          programId={programId}
          programIds={programIds}
          probability={probability}
          onClose={resultsDialog.closeDialog}
          onReset={() => {
            resultsDialog.closeDialog()

            selectEgeDialog.openDialog()
          }}
        />
      </Dialog>

      <Dialog
        open={selectEgeDialog.isActive}
        onClose={onCloseSelectEgeDialog}
        scrollY
        spacing='xlarge'
      >
        <SelectDialog
          programId={programId}
          requiredExams={requiredExams}
          optionalExams={optionalExams}
          selectedExams={selectedExams}
          achievements={achievements}
          onClick={handleCloseSelectEgeDialog}
        />
      </Dialog>
    </>
  )
}

export default memo(OddsAssessment)
